import { render, staticRenderFns } from "./SlideCategoryGroup.vue?vue&type=template&id=468edb34&"
import script from "./SlideCategoryGroup.vue?vue&type=script&lang=js&"
export * from "./SlideCategoryGroup.vue?vue&type=script&lang=js&"
import style0 from "./SlideCategoryGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports